import React from 'react';

function InvalidDetailsSkeleton({ count = 5 }) {
    return (
        <div className="table-responsive invalid-details-table-wrap">
            <table className="table align-middle mb-0 invalid-details-table invalid-details-skeleton-table">
                <thead>
                    <tr>
                        <th className="ps-3" style={{ width: '2.5rem' }}></th>
                        <th>Type</th>
                        <th>Patient</th>
                        <th>Invalid Detail</th>
                        <th>Alternative Contacts</th>
                        <th>Created</th>
                        <th className="text-end pe-3">Actions</th>
                    </tr>
                </thead>
                <tbody>
                    {Array.from({ length: count }).map((_, index) => (
                        <tr key={`invalid-details-skeleton-${index}`}>
                            <td className="ps-3">
                                <div className="invalid-details-skeleton__box invalid-details-skeleton__box--checkbox" />
                            </td>
                            <td>
                                <div className="invalid-details-skeleton__line invalid-details-skeleton__line--badge" />
                            </td>
                            <td>
                                <div className="invalid-details-skeleton__line invalid-details-skeleton__line--medium" />
                            </td>
                            <td>
                                <div className="invalid-details-skeleton__line invalid-details-skeleton__line--long" />
                            </td>
                            <td>
                                <div className="invalid-details-skeleton__line invalid-details-skeleton__line--medium" />
                            </td>
                            <td>
                                <div className="invalid-details-skeleton__line invalid-details-skeleton__line--short" />
                            </td>
                            <td className="text-end pe-3">
                                <div className="invalid-details-skeleton__line invalid-details-skeleton__line--action ms-auto" />
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
}

export default InvalidDetailsSkeleton;
